export default "__VITE_ASSET__QI4$rwTp__"